import axiosInstance from "../../../services/axiosService";

export const roleAPI = {
  getAll: (orgId) => axiosInstance.get(`/user-service/role/org/${orgId}`),

  create: (orgId, data) => axiosInstance.post("/user-service/role", { ...data, org_id: orgId }),

  update: (id, orgId, data) => axiosInstance.patch(`/user-service/role/${id}`, { ...data, org_id: orgId }),

  delete: (id) => axiosInstance.delete(`/user-service/role/${id}`),

  getRoleUsers: (roleId) => axiosInstance.get(`/user-service/role/${roleId}/users`),

  assignUser: (roleId, userId) => axiosInstance.post(`/user-service/role/${roleId}/user/${userId}`),

  removeUser: (roleId, userId) => axiosInstance.delete(`/user-service/role/${roleId}/user/${userId}`),

  searchUsers: (searchTerm, limit = 10) => {
    const url = searchTerm
      ? `/user-services/users?search=${searchTerm}&limit=20`
      : `/user-services/users?limit=${limit}`;
    return axiosInstance.get(url);
  }
};
